import * as React from 'react';
import { Component } from 'react';

import App from './App.jsx';
import XDialog from './XDialog.jsx';

import './css/CollectMkdir.css';

import _ from 'lodash';
import $ from 'jquery';

type T_CollectMkdirProps = {
  app: App
}

export default class CollectMkdir extends Component<T_CollectMkdirProps, T_CollectMkdirState> {
  constructor(props) {
    super(props);

    this.state = {
      nombrePredio: '',
      razonSocial: '',
      response_error: ''
    };

    this.crearRuta = this.crearRuta.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.path !== this.props.path) {
      let inputs = document.getElementsByClassName('collect-input');

      if (!!inputs[0]) {
        inputs[0].value = '';
      }

      if (!!inputs[1]) {
        inputs[1].value = '';
      }

      this.setState({
        nombrePredio: '',
        razonSocial: ''
      });
    }
  }

  razonSocialChange = (ev: SyntheticInputEvent<*>): void => {
    const razonSocial = _.toLower(ev.target.value.split(' ').join('_'));

    this.setState({ razonSocial });
  };

  nombrePredioChange = (ev: SyntheticInputEvent<*>): void => {
    const nombrePredio = _.toLower(ev.target.value.split(' ').join('_'));

    this.setState({ nombrePredio });
  };

  crearRuta = (): void => {
    const
      { app, path } = this.props,
      { nombrePredio, razonSocial } = this.state
    ;

    let newPath = '';
    if (path.split('/').length < 4 && !!nombrePredio && !!razonSocial) {
      newPath = `${path}/${razonSocial}/${nombrePredio}/`;
    } else if (path.split('/').length >= 4 && !!nombrePredio) {
      newPath = `${path}/${nombrePredio}/`;
    }

    $.ajax({
      type: 'GET',
      url: `${app.remote}/collect-create-dir/?dir=${newPath}&session_id=${app.session()}`,
      dataType: 'text',
      async: true
    }).done(res => {
      const _res = JSON.parse(res);

      if (_res.error) {
        // this.setState({ response_error: 'La ruta ingresada ya existe' });
        this.setState({ response_error: _res.error });
      } else {
        this.setState({ response_error: '' });
        this.props.close();
      }
    });
  }

  render() {
    const
      { app, path } = this.props,
      { razonSocial, nombrePredio } = this.state,
      disable_button = path.split('/').length < 4 ? 
        !nombrePredio || !razonSocial 
        : !nombrePredio
      ;

    return (
      <XDialog name="show_collect_mkdir" title="NUEVA RUTA" father={app} drag={true} no_close={false} font={app.favorite_font()} huge_title={true}>
        <div className="CollectMkdir">
          <div className="CollectWrapper">
            <div className="CollectInputWrapper">
              { path.split('/').length < 4 &&
                <input 
                  type="text" 
                  className="collect-input" 
                  placeholder="Ingrese razón social" 
                  defaultValue={this.state.razonSocial} 
                  onChange={this.razonSocialChange}
                />
              }
              <input 
                type="text" 
                className="collect-input" 
                placeholder="Ingrese nombre de predio" 
                defaultValue={this.state.nombrePredio} 
                onChange={this.nombrePredioChange}
              />
            </div>
            <span className='CollectAlert' hidden={!this.state.response_error}>
              {this.state.response_error}
            </span>
            <button 
              type="button" 
              disabled={disable_button} 
              className="collect-btn" 
              onClick={this.crearRuta}
            >
              INGRESAR
            </button>
          </div>
        </div>
      </XDialog>
    );
  }
}


// WEBPACK FOOTER //
// ./src/CollectMkdir.jsx